export const columnsUser = {
  type: 'User',
  fields: [
    {
      queryFragment: {
        selections: [{ name: 'full_name' }, { name: 'user_uid' }]
      },
      description: 'Full Name',
      name: 'full_name',
      column_label: 'Full Name',
      column_label_skip_except_root: false
    },
    {
      queryFragment: {
        selections: [{ name: 'email' }]
      },
      description: 'Email',
      name: 'email'
    },

    {
      name: 'login',
      description: 'Login'
    },
    {
      name: 'sip_username',
      description: 'SIP Number'
    },
    {
      name: 'is_active',
      description: 'Is User Active'
    },
    {
      name: 'mobile_phone',
      description: 'Mobile Phone'
    },
    {
      name: 'contract_start_date',
      description: 'Contract Start Date'
    },
    {
      name: 'contract_end_date',
      description: 'Contract End Date'
    },
    {
      name: `department`,
      description: 'Department',
      type: 'DepartmentType'
    }
  ]
}
export const columnsDepartmentType = {
  type: 'DepartmentType',
  fields: [
    {
      name: 'name',
      description: 'Name'
    }
  ]
}
